export const RoleAssistant = 'Assistant';
export const RoleDoctor = 'Doctor';
